// extracted by mini-css-extract-plugin
export default {"outerDiv":"courses-page_outerDiv__wDnkz","cardOuterDiv":"courses-page_cardOuterDiv__d5RW2","vNameText":"courses-page_vNameText__2VBLw","vDescText":"courses-page_vDescText__O0qDx"};